export const SET_ADMIN_INSTITUTIONS = 'SET_ADMIN_INSTITUTIONS';
export const SET_ADMIN_RADIOLOGISTS = 'SET_ADMIN_RADIOLOGISTS';
export const SET_ADMIN_STUDIES = 'SET_ADMIN_STUDIES';
export const SET_ADMIN_USERS = 'SET_ADMIN_USERS';
export const SET_ADMIN_INSTITUTION_STUDIES = 'SET_ADMIN_INSTITUTION_STUDIES';
export const SET_ADMIN_INSTITUTION_RADIOLOGIST = 'SET_ADMIN_INSTITUTION_RADIOLOGIST';
export const SET_ADMIN_INSTITUTION_RADIOGRAPHER = 'SET_ADMIN_INSTITUTION_RADIOGRAPHER';
export const SET_ADMIN_INSTITUTION_ID = 'SET_ADMIN_INSTITUTION_ID';
export const SET_ADMIN_PROSPECTS = 'SET_ADMIN_PROSPECTS';
export const SET_ADMIN_LOGS = 'SET_ADMIN_LOGS';
